import React, { FunctionComponent } from "react";
import {Footer as ACMFooter} from "acm-components";
import { useSelector } from "react-redux";

import { AppState } from "@store";

const Footer: FunctionComponent = () => {
  const footerVisibility = useSelector(
    (state: AppState) => state.listing.footerVisibility
  );

  return (
    <div
      style={{
        visibility: footerVisibility ? "visible" : "hidden",
        marginTop: "auto"
      }}
    >
      <ACMFooter />
    </div>
  );
};

Footer.displayName = "Footer";

export default Footer;
